import { IAppState } from "../../core/redux/IAppState";
import { ACTION_TYPE } from "../../core/redux/actionType";
import { resourceMap } from "./resourceMap";
import { assoc } from "../module";

export const setLocale = (locale: string) => {
    return {
        type: ACTION_TYPE.SET_LOCALE,
        payload: resourceMap[locale],
    };
};

const localeReducer = (state, action): 
    IAppState => action.type !== ACTION_TYPE.SET_LOCALE ? state : assoc('locale', action.payload, state);

export default localeReducer;